(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pinball-map"] && !Shopify.designMode) return;
  try {
    
  function displayMachines(data) {
    const machines = data.machines;
    const machineList = document.getElementById('pinball-map__machine-list');
    machineList.innerHTML = '';
    machines.forEach(machine => {
      const machineElement = document.createElement('h4');
      machineElement.textContent = machine.name;
      machineList.appendChild(machineElement);
    });
  }

  fetch('https://www.pinballmap.com/api/v1/locations/16910/machine_details.json')
    .then(response => {
      console.log("RESONSE:")
      console.log(response)
      if (response.ok) {
        return response.json();
      } else {
        throw new Error('PINBALL MAP NETWORK RESPONSE ERROR');
      }
    })
    .then(data => {
      displayMachines(data);
    })
    .catch(error => console.error('PINBALL MAP ERROR:', error));

  } catch(e) { console.error(e); }
})();
})();
